import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { FilterOrderFetchAPI } from '../../api/Paymentpost/FilterOrder';
import { OrderReturnFetchAPI } from '../../api/Paymentpost/OrderReturn';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { FaHistory } from 'react-icons/fa';
import { WhatsappFetchAPI } from '../../api/Whatsapp';
import { PaymentOperations } from "../../utils/PaymentOperations"
import { MachinesFetchAPI } from '../../api/Machines';
import { PrinterFetchAPI } from '../../api/Printer';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { PaymentMethodFetchAPI } from '../../api/Paymentpost/PaymentMethod';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import { RenderIf } from '../utils/RenderIf';
import { PluxeeFetchAPI } from '../../api/Pluxee';
import { RequestAlohaFetchAPI } from '../../api/Paymentpost/RequestAloha';
import { PowetranzFetchAPI } from '../../api/Powertranz';
import { YappyFetchAPI } from '../../api/Paymentpost/Yappy';
import { OrdersFetchAPI } from '../../api/Orders';
import imgCheck from "./img/check.png"
import printOrderData from './PrintOrderData';
import moment from 'moment-timezone';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import defaultImage from "../../assets/img/default.png";
import {
   getPaymentIntegrationId,
   kinposPaymentBridge,
   toKinposVoidRecord,
} from '../../utils/KinposBridge';
import { registerLocalKinposVoidHandler } from '../../utils/KinposVoidResultRouter';
import { requestRemoteKinposVoid, confirmRemoteKinposVoid } from '../../utils/KinposRemoteVoidRelay';
import Socket from '../utils/Socket.config';
import { buildAmountReturnLine, getLineGrossValue, splitGrossRefundValue } from '../../new_version/utils/ReturnAmounts';


function ModalReturn({ actvLite, actvPlus, devolution_validation, pos_integration_name, codeParthner }) {
   if (typeof window !== "undefined") {
      window.__SMARTPAY_MODAL_RETURN_TEMPORAL_FIX__ = "cleanup-error-v2";
   }

   const [datatransaction_code, setDataTransaction_code] = useState("");
   const [ModalConfirmation, setModalConfirmation] = useState(false)
   const [order_id, setOrder_id] = useState("");
   const [show, setShow] = useState(false);
   const [transaction_code, setTransaction_code] = useState("")
   const [order, setOrder] = useState({ order: "" })
   const [orderTaxes, setOrderTaxes] = useState([])
   const [orderReturnSize, setOrderReturnSize] = useState(0)
   const [authorizationNumber, setAuthorizationNumber] = useState("")
   const [transactionId, setTransactionId] = useState("")
   const [referenceNumber, setReferenceNumber] = useState("")
   const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
   const [bank_voucher_response, setBank_voucher_response] = useState({ bank_voucher_response: "" })
   const [detailPayment, setDetailPayment] = useState([]);
   const [printers, setPrinters] = useState([]);
   const [selectedProductsToReturn, setSelectedProductsToReturn] = useState([]);
   const [devolutionSummary, setDevolutionSummary] = useState({ items: [], total_returned_items: 0 });
   const kinposVoidResultHandlerRef = useRef(null);
   // Resuelve las promesas de voidKinposLeg cuando llega el resultado terminal de una pierna KinPOS
   // de una devolucion mixta (ver handleKinposVoidResult, chequeo de context.mixed_leg).
   const kinposLegResolversRef = useRef(new Map());
   let machine = localStorage.getItem('machine');
   let token = localStorage.getItem('x-access-machine-token');
   let user = localStorage.getItem('user');
   let datageneral = localStorage.getItem("generalData");
   //get machine
   if (user !== '' && user !== null && user !== undefined) {
      user = JSON.parse(localStorage.getItem('user'))
   }

   if (machine !== '' && machine !== null && machine !== undefined) {
      machine = JSON.parse(localStorage.getItem('machine'))
   }

   if (datageneral !== '' && datageneral !== null && datageneral !== undefined) {
      datageneral = JSON.parse(localStorage.getItem("generalData"));
   }

   const toNumber = (value) => Number(value || 0);
   const roundCurrency = (value) => Number(toNumber(value).toFixed(2));

   const getUnitDiscount = (product = {}) => {
      const amount = toNumber(product.amount) || 1;
      if (product.unit_discount !== undefined && product.unit_discount !== null) return toNumber(product.unit_discount);
      return toNumber(product.discount) / amount;
   };

   const getSegmentIdentity = (product = {}) => {
      if (product.segments_string) return product.segments_string;

      return Array.from(new Set((product.segments || [])
         .map(segment => `${segment.segment_id || ""}:${segment.item_id || segment.item?.item_id || ""}`)
      ))
         .sort()
         .join("|");
   };

   const getComboIdentity = (combo = {}) => {
      if (combo.setGroupString) return combo.setGroupString;

      return (combo.setGroups || [])
         .map(setGroup => {
            const groupIdentity = (setGroup.groups || [])
               .map(group => `${group.group_id || ""}:${getSegmentIdentity(group)}`)
               .sort()
               .join(",");

            return `${setGroup.set_id || ""}:${groupIdentity}`;
         })
         .sort()
         .join("|");
   };

   const getReturnItemKey = (product = {}, type = "group") => {
      if (type === "combo") return `combo-${product.combo_id || ""}-${getComboIdentity(product)}`;
      return `group-${product.group_id || ""}-${getSegmentIdentity(product)}`;
   };

   const getReturnableAmount = (product = {}) => Math.max(0, toNumber(product.return_remaining_amount ?? product.amount));

   // Value (tax included) still refundable on the line, used when returning an amount instead of units
   const getReturnableValue = (product = {}) => Math.max(0, toNumber(product.return_remaining_value ?? getLineGrossValue(product)));

   // A line that already had a partial amount refunded can only keep being refunded by amount
   const isAmountOnlyLine = (product = {}) => product.return_value_mode === true;

   const parseReturnValue = (value) => roundCurrency(parseFloat(value));

   // Returns the reason an amount selection cannot be sent, or "" when it is valid
   const getAmountSelectionIssue = (item) => {
      const value = parseReturnValue(item.value);
      const maxValue = roundCurrency(getReturnableValue(item.product));

      if (value <= 0) return "Digite el monto a devolver.";
      if (value > maxValue + 0.005) return `El monto supera lo disponible ($ ${maxValue.toFixed(2)}).`;
      if (!splitGrossRefundValue(value, item.product.taxes)) return "El monto es demasiado pequeño para una nota de credito.";

      return "";
   };

   const buildReturnSelection = (product, type) => ({
      key: getReturnItemKey(product, type),
      type,
      product,
      amount: getReturnableAmount(product),
      mode: isAmountOnlyLine(product) ? "amount" : "units",
      value: getReturnableValue(product).toFixed(2)
   });

   const getReturnQuantityOptions = (maxAmount) => {
      const amount = Math.max(0, Math.floor(toNumber(maxAmount)));
      return Array.from({ length: amount }, (_, index) => index + 1);
   };

   const findSelectedReturnItem = (product, type) => {
      const key = getReturnItemKey(product, type);
      return selectedProductsToReturn.find(item => item.key === key);
   };

   const scaleProductTaxesForAmount = (product = {}, amount) => {
      const unitDiscount = getUnitDiscount(product);
      const priceAfterDiscount = toNumber(product.price) - unitDiscount;

      return (product.taxes || []).map(tax => ({
         ...tax,
         total: roundCurrency(amount * toNumber(tax.taxtValue) * priceAfterDiscount)
      }));
   };

   const buildProductForReturn = (product = {}, amount) => {
      const returnAmount = Math.max(0, toNumber(amount));
      const unitDiscount = getUnitDiscount(product);

      return {
         ...product,
         amount: returnAmount,
         cantidadItem: returnAmount,
         discount: roundCurrency(unitDiscount * returnAmount),
         unit_discount: unitDiscount,
         taxes: scaleProductTaxesForAmount(product, returnAmount)
      };
   };

   const getAllProductsToReturn = (sourceOrder = order, includeUnavailable = false) => {
      const items = [
         ...(sourceOrder.groups || []).map(product => ({
            key: getReturnItemKey(product, "group"),
            type: "group",
            product
         })),
         ...(sourceOrder.combos || []).map(combo => ({
            key: getReturnItemKey(combo, "combo"),
            type: "combo",
            product: combo
         }))
      ];

      return includeUnavailable
         ? items
         : items.filter(item => getReturnableAmount(item.product) > 0);
   };

   const hydrateOrderWithReturnAvailability = (orderData, summary = {}) => {
      const summaryByKey = new Map((summary.items || []).map(item => [item.key, item]));

      const hydrateLine = (product, type) => {
         const key = getReturnItemKey(product, type);
         const lineSummary = summaryByKey.get(key);
         const originalAmount = toNumber(lineSummary?.original_amount ?? product.amount);
         const returnedAmount = toNumber(lineSummary?.returned_amount);
         const remainingAmount = Math.max(0, toNumber(lineSummary?.remaining_amount ?? (originalAmount - returnedAmount)));
         const originalValue = toNumber(lineSummary?.original_value ?? getLineGrossValue(product));
         const returnedValue = toNumber(lineSummary?.returned_value);
         const remainingValue = Math.max(0, toNumber(lineSummary?.remaining_value ?? (originalValue - returnedValue)));

         return {
            ...product,
            return_key: key,
            return_original_amount: originalAmount,
            returned_amount: returnedAmount,
            return_remaining_amount: remainingAmount,
            return_original_value: originalValue,
            returned_value: returnedValue,
            return_remaining_value: remainingValue,
            return_value_mode: lineSummary?.value_mode === true
         };
      };

      return {
         ...orderData,
         groups: (orderData.groups || []).map(product => hydrateLine(product, "group")),
         combos: (orderData.combos || []).map(combo => hydrateLine(combo, "combo"))
      };
   };

   const getSelectedReturnProducts = (type) => (
      selectedProductsToReturn
         .filter(item => item.type === type)
         .map(item => (
            item.mode === "amount"
               ? buildAmountReturnLine(item.product, parseReturnValue(item.value))
               : buildProductForReturn(item.product, item.amount)
         ))
   );

   const calculateReturnTotals = (groups = [], combos = []) => {
      const totals = { subtotal: 0, tax: 0, discount: 0, total: 0, taxes: {} };

      const addLine = (product = {}) => {
         const amount = toNumber(product.amount);
         const unitDiscount = getUnitDiscount(product);
         const lineDiscount = roundCurrency(unitDiscount * amount);
         const lineSubtotal = roundCurrency(amount * toNumber(product.price) - lineDiscount);
         // A line refunded by amount already carries the tax totals worked out for that amount
         const taxes = product.refund_mode === "amount" ? (product.taxes || []) : scaleProductTaxesForAmount(product, amount);

         totals.subtotal += lineSubtotal;
         totals.discount += lineDiscount;

         taxes.forEach(tax => {
            const key = tax.tax_id || tax.tax || tax.percentage || "tax";
            if (!totals.taxes[key]) {
               totals.taxes[key] = { ...tax, total: 0 };
            }
            totals.taxes[key].total += toNumber(tax.total);
            totals.tax += toNumber(tax.total);
         });
      };

      groups.forEach(addLine);
      combos.forEach(addLine);

      totals.subtotal = roundCurrency(totals.subtotal);
      totals.tax = roundCurrency(totals.tax);
      totals.discount = roundCurrency(totals.discount);
      totals.total = roundCurrency(totals.subtotal + totals.tax);
      totals.taxes = Object.values(totals.taxes).map(tax => ({ ...tax, total: roundCurrency(tax.total) }));

      return totals;
   };

   const getSelectedReturnTotals = () => (
      calculateReturnTotals(getSelectedReturnProducts("group"), getSelectedReturnProducts("combo"))
   );

   const isFullOriginalReturnSelected = () => {
      const allItems = getAllProductsToReturn(order, true);
      const hasPreviousReturns = toNumber(devolutionSummary?.total_returned_items) > 0 || devolutionSummary?.has_devolutions === true;

      if (hasPreviousReturns || allItems.length === 0 || selectedProductsToReturn.length !== allItems.length) {
         return false;
      }

      // Refunding an amount is always partial, even when every line is selected
      if (selectedProductsToReturn.some(item => item.mode === "amount")) {
         return false;
      }

      return allItems.every(item => {
         const selectedItem = selectedProductsToReturn.find(selected => selected.key === item.key);
         return selectedItem && toNumber(selectedItem.amount) === toNumber(item.product.amount);
      });
   };

   //get order
   const getOrder = async () => {
      console.log("Estoy en consultar orden");
      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'));

      let business_code = business.code
      let branch_code = branchoffice.code

      if (codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      try {

         const response = await FilterOrderFetchAPI.getOrder(transaction_code, branch_code, business_code, token)
         console.log(response);
         let getorder = response.data.order
         const returnSummary = response.data.devolution_summary || { items: [], total_returned_items: 0 };
         getorder.paymentmethod_params = response.data.paymentmetod
         // Terminal (machine_per_branchoffice.code) donde se cobro esta orden con KinPOS/PAX. Se
         // usa para decidir si la anulacion debe enrutarse por WebSocket a ese punto.
         getorder.origin_machine_code = response.data.origin_machine_code || null;
         getorder.origin_machine_name = response.data.origin_machine_name || null;
         //format json 
         for (let i = 0; i < getorder.groups.length; i++) {
            for (let s = 0; s < getorder.groups[i].segments.length; s++) {
               getorder.groups[i].segments[s].item_id = getorder.groups[i].segments[s].item.item_id
               getorder.groups[i].segments[s].name = getorder.groups[i].segments[s].item.name
               getorder.groups[i].segments[s].cantidadItem = getorder.groups[i].segments[s].item.amount
               getorder.groups[i].segments[s].description = getorder.groups[i].segments[s].item.description
               getorder.groups[i].segments[s].img = getorder.groups[i].segments[s].item.img
            }
            getorder.groups[i].DetalleSegmentos = getorder.groups[i].segments
            getorder.groups[i].cantidadItem = getorder.groups[i].amount
            getorder.groups[i].descuento = getorder.groups[i].discount
            //getorder.groups[i].taxtValue = getorder.groups[i].tax.amount
            //getorder.groups[i].tax = getorder.groups[i].tax.percentage
         }

         //Format the taxes json
         let groupedTaxes = Object.values(
            getorder.taxes.reduce((acc, item) => {
               if (!acc[item.tax]) {
                  acc[item.tax] = { tax: item.tax, total: 0 };
               }
               acc[item.tax].total += item.total;
               return acc;
            }, {})
         )

         if (getorder.bank_voucher_response != "0" && getorder.order_type != "devolution") {
            getorder.bank_voucher_response = JSON.parse(getorder.bank_voucher_response)
         }

         const orderWithAvailability = hydrateOrderWithReturnAvailability(getorder, returnSummary);

         setOrder(orderWithAvailability);
         setDevolutionSummary(returnSummary);

         const productsToSelect = getAllProductsToReturn(orderWithAvailability)
            .map(item => buildReturnSelection(item.product, item.type));

         setSelectedProductsToReturn(productsToSelect);

         setOrderTaxes(groupedTaxes)
         console.log(response);
         console.log(response.data.order.bank_voucher_response);
         setBank_voucher_response(response.data.order.bank_voucher_response);
         setDetailPayment(response.data.paymentmetod)
      } catch (err) {
         ErrorAlert('', 'Error de consulta', 'error')
         console.log(err);
      }
   }

   //Function to select the products to return in case of partial return, if the product is already selected we remove it from the state, if not we add it. We identify the products by their group_id or combo_id and the type (group or combo) to avoid conflicts between groups and combos with the same id.
   const toggleProductToReturn = (product, type = "group") => {
      const productKey = getReturnItemKey(product, type);
      const remainingAmount = getReturnableAmount(product);

      if (remainingAmount <= 0) return;

      setSelectedProductsToReturn(prev => {
         const exists = prev.some(item => item.key === productKey);

         if (exists) {
            return prev.filter(item => item.key !== productKey);
         }

         return [...prev, buildReturnSelection(product, type)];
      });
   };

   // Switches a selected line between returning units and returning an amount of money
   const handleReturnModeChange = (product, type, mode) => {
      if (mode === "units" && isAmountOnlyLine(product)) return;

      const productKey = getReturnItemKey(product, type);

      setSelectedProductsToReturn(prev => prev.map(item => (
         item.key === productKey
            ? { ...item, mode, amount: getReturnableAmount(product), value: getReturnableValue(product).toFixed(2) }
            : item
      )));
   };

   // The raw text is kept so the cashier can type "1." or "0.5"; it is validated before sending
   const handleReturnValueChange = (product, type, rawValue) => {
      const productKey = getReturnItemKey(product, type);

      setSelectedProductsToReturn(prev => prev.map(item => (
         item.key === productKey ? { ...item, value: rawValue } : item
      )));
   };

   const handleReturnQuantityChange = (product, type, value) => {
      const productKey = getReturnItemKey(product, type);
      const remainingAmount = getReturnableAmount(product);
      const numericValue = Math.floor(toNumber(value));
      const amount = Math.max(0, Math.min(numericValue, remainingAmount));

      setSelectedProductsToReturn(prev => {
         const exists = prev.some(item => item.key === productKey);

         if (amount <= 0) {
            return prev.filter(item => item.key !== productKey);
         }

         if (exists) {
            return prev.map(item => item.key === productKey ? { ...item, amount } : item);
         }

         return [...prev, { ...buildReturnSelection(product, type), amount }];
      });
   };

   const toggleSelectAllProductsToReturn = () => {
      const allProducts = getAllProductsToReturn();

      if (selectedProductsToReturn.length === allProducts.length) {
         setSelectedProductsToReturn([]);
         return;
      }

      setSelectedProductsToReturn(allProducts.map(item => buildReturnSelection(item.product, item.type)));
   };

   //Function to handle the return action, if the return type is partial we check if at least one product is selected, if not we show an alert, if everything is ok we create the temp order for the return
   const handleReturnAction = () => {
      if (kinposPaymentBridge.getPendingPayment()?.mode === "void") {
         ErrorAlert(
            "Ya existe una anulacion KinPOS pendiente de confirmacion o registro. No inicies otra anulacion.",
            "Anulacion KinPOS pendiente",
            "warning",
            10000
         );
         return;
      }
      const availableProductsCount = getAllProductsToReturn(order).length;

      if (availableProductsCount === 0) {
         ErrorAlert("Esta orden ya no tiene productos disponibles para nota de credito.", "Sin productos disponibles", "warning");
         return;
      }

      if (selectedProductsToReturn.length === 0) {
         ErrorAlert("Debe seleccionar al menos un producto para devolver.", "Advertencia", "warning");
         return;
      }

      const invalidAmountSelection = selectedProductsToReturn.find(item => item.mode === "amount" && getAmountSelectionIssue(item));

      if (invalidAmountSelection) {
         ErrorAlert(
            `${invalidAmountSelection.product?.name || "Producto"}: ${getAmountSelectionIssue(invalidAmountSelection)}`,
            "Monto no valido",
            "warning"
         );
         return;
      }

      const invalidSelection = selectedProductsToReturn.find(item => (
         item.mode !== "amount"
         && (toNumber(item.amount) <= 0 || toNumber(item.amount) > getReturnableAmount(item.product))
      ));

      if (invalidSelection) {
         ErrorAlert(
            `La cantidad de ${invalidSelection.product?.name || "producto"} supera lo disponible: ${getReturnableAmount(invalidSelection.product)}.`,
            "Cantidad no disponible",
            "warning"
         );
         return;
      }

      if (getPaymentIntegrationId(order) === 10 && !isFullOriginalReturnSelected()) {
         ErrorAlert(
            "KinPOS/PAX solo permite anular la venta completa. No admite devoluciones parciales ni ordenes con devoluciones anteriores.",
            "Anulacion KinPOS no disponible",
            "warning",
            10000
         );
         return;
      }

      createOrderTempReturn();
   };

   //get printer 
   let arrayPrintersTemp = []
   const getPrinter = async () => {
      try {
         const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

         let arrayPrinters = response.data.printers;
         let printer_Comanda = "";
         let printer_ticket = ""
         let printer_zebra = "";
         let printer_ip = "";

         for (let i = 0; i < arrayPrinters.length; i++) {

            getCategoriesByprinter(arrayPrinters[i])

            if (arrayPrinters[i].printer_type == 'Tickets') {
               printer_ticket = arrayPrinters[i].printer_name
               printer_ip = arrayPrinters[i].ip || ""
            } else if (arrayPrinters[i].printer_type == 'Comanda') {
               printer_Comanda = arrayPrinters[i].printer_name
            }
         }

         setPrinters(arrayPrintersTemp)
         setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_ip: printer_ip });

      } catch (err) {
         console.log(err);
      }
   }

   const getCategoriesByprinter = async (printer) => {

      try {
         const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
         printer.categories = response.data.categories

      } catch (err) {
         printer.categories = []
         console.log(err);
      }
      arrayPrintersTemp.push(printer)

   }

   //Function to create a temp order return 
   const [stateRequest, setStateRequest] = useState(false)
   const createOrderTempReturn = async () => {
      if (stateRequest == false) {
         LoadingAlert()
         setStateRequest(true)
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
         let machine = JSON.parse(localStorage.getItem('machine'));

         let groupsToReturn = getSelectedReturnProducts("group");
         let combosToReturn = getSelectedReturnProducts("combo");
         let returnTotals = calculateReturnTotals(groupsToReturn, combosToReturn);

         let jsonDiscountTemp = {
            "client_name": order.client_name,
            "client_id": order.client_id !== undefined && order.client_id != 0 ? order.client_id : 0,
            "client_ruc": order.client_ruc,
            "client_dv": order.client_dv,
            "cupon_code": "0",
            "is_cupon": false,
            "localizador": "0",
            "client_phone": "0",
            "dgi_qr": "0",
            "Orden": groupsToReturn,
            "combos": combosToReturn,
            "partial_devolution_items": selectedProductsToReturn.map(item => ({
               type: item.type,
               id: item.product.group_id || item.product.combo_id,
               name: item.product.name,
               amount: item.mode === "amount" ? 1 : item.amount,
               available_amount: getReturnableAmount(item.product),
               price: item.product.price,
               ...(item.mode === "amount" ? { mode: "amount", refund_value: parseReturnValue(item.value) } : {})
            })),
            "Descuento": returnTotals.discount,
            "Total": returnTotals.total,
            "itbms": returnTotals.tax,
            "taxes": returnTotals.taxes,
            "subtotal": returnTotals.subtotal,
            "machine_id": machine.id,
            "branchoffice_id": branchoffice.id,
            "tipoOrden": order.order_type,
            "paymethod": order.paymenthod,
            "is_discount_notification": false,
            "is_devolution_notification": true,
            "order_code_reference": transaction_code,
            "user": {
               id: user.id,
               name: user.name,
               code: user.user_code
            },

         }

         //We check if the order has delivery info to send it to the temp order
         if (order.delivery) {
            jsonDiscountTemp.delivery = order.delivery
         }


         //We check if the order is for a banesco pay 
         if (order.paymenthod_integration_id === 4) {
            jsonDiscountTemp.is_banesco_pay = true;
            jsonDiscountTemp.banesco_reference = order.bank_voucher_response.TxnInvoice;
         }

         //wE CHECK IF THE ORDER HAS MICROS PARAMS TO SEND 
         if (datageneral[0].data.business && datageneral[0].data.business.pos_integration_name === "Micros" && datageneral[0].data.business.pos_integration_params !== null) {
            jsonDiscountTemp.micros_reference = {
               checkSeq: order.micros_reference.checkSeq,
               checkNum: order.micros_reference.checkNum
            }
         }
         //We check if the order is already a devolution 
         if (order.order_type === "devolution") {
            ErrorAlert('Este numero de orden, corresponde a una devolución', 'Error', 'info', 5000)
            setStateRequest(false)
         } else {
            try {
               //We create the temp order 
               await OrderReturnFetchAPI.createTempReturn(jsonDiscountTemp, token)

               if (devolution_validation === 0) {
                  LoadingAlert("Devolucion en proceso", "Espere un momento por favor...")
               } else {
                  LoadingAlert("Solicitud de devolución", "Espere un mientras el administrador aprueba la devolucion")
               }

               getOrderTempReturn()

               try {
                  const response = await WhatsappFetchAPI.sentDiscountNotification(jsonDiscountTemp, token)
                  console.log(response)
               } catch (err) {
                  console.log(err)
               }
            } catch (err) {
               console.log(err.response.data.error);
               setStateRequest(false);

               if (err.response.data.error === "La maquina ya tiene una orden en progreso") {
                  //getOrderTempReturn(true)
                  getTemporalOrdersByBranch()

               } else {
                  ErrorAlert(err.response.data.error, 'Error', 'warning')
               }

               ErrorAlert(err.response.data.error, 'Error', 'warning')
            }
         }
      }
   }


   const actualDate = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD')
   const minDate = moment(actualDate).subtract(1, 'months').format('YYYY-MM-DD');

   const getTemporalOrdersByBranch = async () => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'));
      let business = JSON.parse(localStorage.getItem('business'));
      try {
         //We call the transaction info 
         const response = await OrdersFetchAPI.getTemporalOrdersByBranch(business.code, branchoffice.code, minDate, actualDate + 'T23:59:59.000+00:00', token);
         //This are for the discount temporal orders 
         let data_orders_Temporal = response.data.temp_orders;
         // Filtrar por machine_code "3973"
         data_orders_Temporal = data_orders_Temporal.filter(order => order.machine_code === machine.code && (order.is_devolution_notification === true || order.is_discount_notification === true));

         if (data_orders_Temporal.length > 0) {
            updateTemReturn(data_orders_Temporal[0].code, 5, "", "", "", true)
         } else {
            setStateRequest(false)
            ErrorAlert("No se encontro una temporal pendiente para eliminar.", "Temporal no encontrada", "warning")
         }
      } catch (err) {
         //We show the error alert 
         ErrorAlert('No tiene información')
         console.log(err);
      }
   }




   //get order temporal return
   let instervalReturn = 0
   let countReturn = 0
   let orderSize = 0
   const getOrderTempReturn = async (isTruncate) => {

      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'));
      let machine = JSON.parse(localStorage.getItem('machine'))

      let business_code = business.code
      let branch_code = branchoffice.code

      if (codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      clearInterval(instervalReturn)
      try {
         const response = await OrderReturnFetchAPI.getTempReturn(machine.code, business_code, branch_code, transaction_code, token)
         console.log(response);
         console.log(response.data.order.groups.length);
         orderSize = response.data.order.groups.length
         setOrderReturnSize(response.data.order.groups.length)
         //-----------------------------------------------------------------

         let code = response.data.order.code
         let message = ""
         let title = ""
         let icon = ""

         if (isTruncate == true) {
            setStateRequest(false);
            updateTemReturn(code, 5, "", "", "", isTruncate)

         } else {

            if (devolution_validation === 0) {
               approvedReturn()
            } else {
               if (response.data.order.status_id == 1) {
                  if (countReturn <= 5) {
                     instervalReturn = setInterval(getOrderTempReturn, 5000)
                     countReturn++
                  } else {
                     message = "Tiempo de espera agotado"
                     title = "Advertencia"
                     icon = "warning"
                     updateTemReturn(code, 5, message, title, icon) //state 5 delete order dicount
                     setStateRequest(false);
                     setShow(false)
                     countReturn = 0
                  }
               } else if (response.data.order.status_id == 8) {//order temporal is cancel
                  message = "Orden devolucion cancelada."
                  title = "Operacion denegada"
                  icon = "error"
                  setStateRequest(false);
                  updateTemReturn(code, 5, message, title, icon)
                  setShow(false)
               } else if (response.data.order.status_id == 9) {//order temporalsuccess
                  approvedReturn()
               }
            }
         }


         function approvedReturn() {
            message = "Devolucion aplicada con exito."
            title = "Operacion exitosa"
            icon = "success"
            console.log("lo que tiene orden es", order);
            //wE CHECK IF THE ORDER HAS MICROS PARAMS TO SEND 
            if (datageneral[0].data.business && datageneral[0].data.business.pos_integration_name === "Micros" && datageneral[0].data.business.pos_integration_params !== null) {
               let host_url = datageneral[0].data.business.pos_integration_params.host_url;
               let employeeNum = datageneral[0].data.business.pos_integration_params.employeeNum;
               let RvcRef = datageneral[0].data.business.pos_integration_params.RvcRef;
               let localMicrosServerIp = datageneral[0].data.business.pos_integration_params.localMicrosServerIp;
               //We make the void on micros
               voidCheckMicrosOrderLocal(localMicrosServerIp, RvcRef, employeeNum, host_url, response.data.order.micros_reference.checkSeq, response.data.order.micros_reference.checkNum, token)
            }
            //KinPOS/PAX uses the Android JSBridge and only supports a full KP_Void.
            if (getPaymentIntegrationId(order) === 10) {
               voidKinpos(
                  code,
                  response.data.order.devolution_order_reference?.approved_by
               );
               return;
            }
            //Mixto: reversa cada pierna por su propio datafono (si la devolucion es completa), con
            //fallback a efectivo por pierna cuando no hay evidencia capturada o el datafono no aprueba.
            if (order.paymenthod.toUpperCase() === "MIXTO") {
               voidMixedOrder(
                  code,
                  response.data.order.devolution_order_reference?.approved_by
               );
               return;
            }
            //We check if the payment method integration is 6 (Evertech)
            if (order.paymenthod_integration_id === 6) {
               voidEvertech(code, message, title, icon);
               //Integration banesco
            } else if (order.paymenthod_integration_id === 4) {
               voidBanesco(code, message, title, icon);
               //Integration pluxee
            } else if (order.paymenthod_integration_id === 7) {
               //We check if the payment method is pluxee
               if (order.paymenthod_id === 21) {
                  reversalPluxee(code, message, title, icon, order.machine_id);
               } else {
                  reversalPluxeeVoucher(code, message, title, icon, order.machine_id);
               }
            } else if (order.paymenthod_integration_id === 2) {
               //Check if the difference is less than 24 hours
               //We check if the payment method is yappy qr
               if (order.paymenthod_id === 19) {
                  reversalYappyQr(order.yappy_transaction_id, code, message, title, icon);
               }
               //We check if the payment method is yappy btn
               if (order.paymenthod_id === 6) {
                  reversalYappyBtn(order.yappy_transaction_id, code, message, title, icon);
               }
            }
            //We check if the payment method is credit or debit
            else if (bank_voucher_response == "0" || order.paymenthod.toUpperCase() === "CLAVE" || order.paymenthod.toUpperCase() === "YAPPY" || order.paymenthod.toUpperCase() === "YAPPY QR" || order.paymenthod_integration_id === 3) {
               let newVoucher = { EMVStreamResponse: "0" };
               registerOrderTempReturn(code, 3, message, title, icon, newVoucher, response.data.order.devolution_order_reference.approved_by);
            } else if (order.paymenthod_integration_id === 5) {
               //We check if the payment method is powertranz
               if (order.paymenthod_id === 40) {
                  voidPowertranz(code, message, title, icon);
               }
            }
            else {
               voidCreditDebit(code, message, title, icon);
            }


            //updateTemReturn(code, 3, message, title, icon);
            setAuthorizationNumber(order.bank_voucher_response.authorizationNumber);
            setTransactionId(order.bank_voucher_response.transactionId)
            setReferenceNumber(order.bank_voucher_response.referenceNumber)
            //We clean the state of the products checked 
            setShow(false)
            setStateRequest(false);
         }
         //-----------------------------------------------------------------
      } catch (err) {
         setStateRequest(false)
         console.log(err);
         ErrorAlert("Error de transaccion de la temporal.", "Error de temporal", "error")

      }
   }

   //Refund powertranz
   const refundPowertranz = async (TotalAmount, code, message, title, icon) => {
      try {
         let data = { "TransactionIdentifier": bank_voucher_response.TransactionIdentifier, "TotalAmount": TotalAmount, "TipAmount": 0, "TaxAmount": 0, "Refund": true }
         let headers = {
            'x-access-token': token,
            'X-PowerTranz-Id': bank_voucher_response?.X_PowerTranz_Id,
            'X-PowerTranz-Password': bank_voucher_response?.X_PowerTranz_Password
         }
         const response = await PowetranzFetchAPI.refund(data, headers);

         console.log("Data refund", response.data.data);
         let approved = response.data.data.Approved;
         let responseRefundData = bank_voucher_response
         responseRefundData.void = response.data.data

         let datafilter = response.data.data
         const now = new Date(); // Gets current date and time
         const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
         const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
         responseRefundData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  DEVOLUCION  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  DEVOLUCION  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
         let newVoucher = { EMVStreamResponse: responseRefundData }

         if (approved == true) {
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            message = response.data.data.ResponseMessage || "No se aplico la devlucion."
            title = response.data.data.Errors.Message || "Error en la devolucion "
            icon = "error"
            updateTemReturn(code, 5, message, title, icon)
         }
      } catch (err) {
         message = "No se aplico la devlucion."
         title = "Error en la devolucion "
         icon = "error"

         updateTemReturn(code, 5, message, title, icon)
      }
   }

   //Void powertranz
   const voidPowertranz = async (code, message, title, icon) => {
      let data = { "TransactionIdentifier": bank_voucher_response.TransactionIdentifier }
      console.log("data", data);


      try {

         let headers = {
            'x-access-token': token,
            'X-PowerTranz-Id': bank_voucher_response?.X_PowerTranz_Id,
            'X-PowerTranz-Password': bank_voucher_response?.X_PowerTranz_Password
         }
         const response = await PowetranzFetchAPI.void(data, headers);
         let approved = response.data.data.Approved;
         let responseVoidData = bank_voucher_response
         responseVoidData.powertranzResponse = response.data.data

         let datafilter = response.data.data
         const now = new Date(); // Gets current date and time
         const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
         const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
         responseVoidData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  ANULADO  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  ANULADO  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
         let newVoucher = { EMVStreamResponse: responseVoidData }
         if (approved == true) {
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            refundPowertranz(order.total, code, message, title, icon)
         }

      } catch (err) {

         message = "No se aplico la devlucion."
         title = "Error en la devolucion "
         icon = "error"

         updateTemReturn(code, 5, message, title, icon)
         console.log(err);
      }
   }

   //We make the void on micros  
   const voidCheckMicrosOrderLocal = async (ip, RvcRef, employeeNum, host_url, checkSeq, checkNum, token) => {
      let data = {
         Ruta: `http://${ip}:9472/api/micros/check?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`,
         Type: "post",
         Header: { "x-access-token": token },
         Body: {
            "checkNum": checkNum,
            "checkSeq": checkSeq
         }
      }
      let micros_response;
      console.log("entre a peticion local micros");

      try {
         micros_response = await RequestLocalFetchAPI.postMicros(data);
         console.log(micros_response);
      } catch (err) {
         console.log(err);
      }
   }

   //Reverse yappy qr 
   const reversalYappyQr = async (yappy_transaction_id, code, message, title, icon) => {
      try {
         let token = localStorage.getItem('x-access-machine-token');
         const response = await YappyFetchAPI.reverseYappyTransaction({ yappy_transaction_id: yappy_transaction_id, params: [] }, token);
         let newVoucher = { EMVStreamResponse: "Transaccion reversada #" + yappy_transaction_id }
         //We register the order if the response is success
         if (response && response.data && response.data.status === true) {
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
         }
      } catch (err) {
         console.log(err);
         if (err.response) {
            console.log(err.response)
            if (err.response.data && err.response.data.error.code === "YP-0002") {
               registerOrderTempReturn(code, 3, message, title, icon, { EMVStreamResponse: 0 }, undefined, "error");
            } else {
               //If we can't reverse the transaction on yappy,  we reverse on efective 
               registerOrderTempReturn(code, 3, message, title, icon, { EMVStreamResponse: 0 }, undefined, "error");
            }
         } else {
            console.log("aqui puto")
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")

         }
      }
   }

   //Reverse yappy btn 
   const reversalYappyBtn = async (yappy_transaction_id, code, message, title, icon) => {
      try {
         let token = localStorage.getItem('x-access-machine-token');
         const response = await YappyFetchAPI.reverseYappyBtnTransaction({ yappy_transaction_id: yappy_transaction_id, params: [] }, token);
         let newVoucher = { EMVStreamResponse: "Transaccion reversada #" + yappy_transaction_id }
         //We register the order if the response is success
         if (response && response.data && response.data.status === true) {
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
         }
      } catch (err) {
         if (err.response) {
            if (err.response.data && err.response.data.error.code === "YP-0002") {
               registerOrderTempReturn(code, 3, message, title, icon, { EMVStreamResponse: 0 }, undefined, "error");
            } else {
               //If we can't reverse the transaction on yappy,  we reverse on efective 
               registerOrderTempReturn(code, 3, message, title, icon, { EMVStreamResponse: 0 }, undefined, "error");
            }
         } else {
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")

         }
      }
   }

   // ---- Devolucion mixta: reversa por pierna con fallback a efectivo ----
   // order.paymethods[] solo trae evidencia por pierna (voucher_response) para las ordenes cobradas
   // DESPUES de que esto se implemento. Una pierna sin evidencia, o cuyo datafono no aprueba, cae a
   // efectivo automaticamente - nunca bloquea el resto de la devolucion.

   const parseLegVoucherResponse = (leg) => {
      if (!leg?.voucher_response || leg.voucher_response === "0" || leg.voucher_response === 0) return null;
      try {
         return typeof leg.voucher_response === "string" ? JSON.parse(leg.voucher_response) : leg.voucher_response;
      } catch (error) {
         return null;
      }
   };

   // Reversa generica via el middleware local de Windows. En un pago Mixto, Evertech/Banesco/Bac se
   // cobran todas por el mismo VOID generico (no por sus endpoints dedicados de una sola orden),
   // porque es la unica evidencia que efectivamente se captura por pierna.
   const voidCreditDebitLeg = async (leg) => {
      const voucher = parseLegVoucherResponse(leg);
      if (!voucher?.authorizationNumber || !voucher?.referenceNumber || !voucher?.systemTraceNumber) {
         return { success: false };
      }
      try {
         const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token);
         const response_paymentmethod = await PaymentMethodFetchAPI.getPaymentMethod(machine.id, token);
         const machinePaymentMethods = Array.isArray(response_paymentmethod.data.data) ? response_paymentmethod.data.data : [];
         const machinePaymentMethod = machinePaymentMethods.find((method) => method.id === leg.paymethod_id) || {};
         const json = [{
            Tipo: 'VOID',
            TipoVenta: "VOID",
            authorizationNumber: voucher.authorizationNumber,
            referenceNumber: voucher.referenceNumber,
            systemTraceNumber: voucher.systemTraceNumber,
            paymentMethod: {
               id: leg.paymethod_id,
               payment: leg.name,
               payment_id: leg.paymethod_id,
               machine_id: machine.id,
               params: machinePaymentMethod.params || detailPayment
            }
         }];
         const response = await RequestLocalFetchAPI.postPaymentMethod(json, response_machine.data.data.windows_ip);
         const approved = response?.data?.data?.EMVStreamResponse?.responseCodeDescription === "APROBADA";
         return approved
            ? { success: true, voucher_response: JSON.stringify(response.data.data.EMVStreamResponse) }
            : { success: false };
      } catch (error) {
         return { success: false };
      }
   };

   // Reversa Yappy (QR si paymethod_id 19, Boton si 6) para una pierna de un pago Mixto.
   const voidYappyLeg = async (leg) => {
      const voucher = parseLegVoucherResponse(leg);
      if (!voucher?.yappy_transaction_id) return { success: false };
      try {
         const reverseFn = leg.paymethod_id === 19
            ? YappyFetchAPI.reverseYappyTransaction
            : YappyFetchAPI.reverseYappyBtnTransaction;
         const response = await reverseFn({ yappy_transaction_id: voucher.yappy_transaction_id, params: [] }, token);
         return response?.data?.status === true
            ? { success: true, voucher_response: JSON.stringify({ info: "Transaccion reversada #" + voucher.yappy_transaction_id }) }
            : { success: false };
      } catch (error) {
         return { success: false };
      }
   };

   // Reversa KinPOS para una pierna de un pago Mixto: local si este dispositivo cobro la orden,
   // remota (mismo relay cross-point de la devolucion simple) si la cobro otro punto. El resultado
   // se resuelve via kinposLegResolversRef en vez de terminar el flujo como hace handleKinposVoidResult
   // para una orden simple - aqui solo se reporta {success, voucher_response, finalize} al
   // orquestador, que decide cuando confirmar/ACK una vez conocido el resultado del registro
   // combinado de TODAS las piernas.
   // KinPOS/PAX solo admite UNA operacion pendiente a la vez en todo el dispositivo (local o el que
   // ejecuta el void remoto) - con 2+ piernas KinPOS en la misma orden Mixta, la SEGUNDA no puede ni
   // empezar si la primera sigue "pendiente" sin ACK. Por eso aqui el ACK/confirm se hace de
   // inmediato en cuanto se conoce el resultado terminal de ESTA pierna (igual que ya hace
   // handleKinposVoidResult para una orden simple cuando el resultado no es "approved" - nada que
   // registrar, se confirma ya), en vez de esperar a que voidMixedOrder registre la nota combinada al
   // final. El riesgo que se acepta: si esta pierna SI aprobo pero el registro combinado final falla,
   // la anulacion fisica ya quedo hecha y confirmada en Android (no se puede ni hace falta repetirla);
   // solo el registro de la nota de credito queda pendiente de reintentar (la temporal se conserva via
   // keepTemporalOnFailure).
   const voidKinposLeg = async (leg) => {
      const voucher = parseLegVoucherResponse(leg);
      const receiptNumber = voucher?.transaction?.receipt;
      if (!receiptNumber) return { success: false };

      const branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
      const business = JSON.parse(localStorage.getItem('business'));
      const businessCode = codeParthner != 0 ? codeParthner.business_code : business.code;
      const branchCode = codeParthner != 0 ? codeParthner.branchoffice_code : branchoffice.code;
      const isDifferentOriginPoint = order.origin_machine_code && order.origin_machine_code !== machine.code;
      const legPayment = { paymenthod_id: leg.paymethod_id, paymenthod_integration_id: leg.paymenthod_integration_id };

      if (isDifferentOriginPoint) {
         let socket;
         try {
            socket = Socket({ machine_code: machine.code, branchoffice_code: branchCode, business_code: businessCode });
            const { remote_request_id, kinpos_request_id, result } = await requestRemoteKinposVoid(socket, {
               targetMachineCode: order.origin_machine_code,
               businessCode,
               branchofficeCode: branchCode,
               requestingMachineCode: machine.code,
               orderReference: transaction_code,
               receiptNumber,
               payment: legPayment,
               context: { mixed_leg: true },
            });
            const approved = result.status === "approved";
            confirmRemoteKinposVoid(socket, {
               remoteRequestId: remote_request_id,
               kinposRequestId: kinpos_request_id,
               targetMachineCode: order.origin_machine_code,
               businessCode,
               branchofficeCode: branchCode,
               success: true,
            });
            socket.disconnect();
            if (!approved) return { success: false };
            return { success: true, voucher_response: JSON.stringify(toKinposVoidRecord(result)) };
         } catch (error) {
            socket?.disconnect();
            return { success: false };
         }
      }

      if (!kinposPaymentBridge.isAvailable()) return { success: false };

      try {
         const request = await kinposPaymentBridge.voidTransaction({
            payment: legPayment,
            orderReference: transaction_code,
            receiptNumber,
            context: { mixed_leg: true },
         });
         const result = await new Promise((resolve) => {
            kinposLegResolversRef.current.set(request.request_id, resolve);
         });
         kinposPaymentBridge.complete(result.request_id);
         if (result.status !== "approved") return { success: false };
         return { success: true, voucher_response: JSON.stringify(toKinposVoidRecord(result)) };
      } catch (error) {
         return { success: false };
      }
   };

   const voidMixedLeg = async (leg) => {
      if (leg.paymenthod_integration_id === 10) return voidKinposLeg(leg);
      const voucher = parseLegVoucherResponse(leg);
      if (voucher?.yappy_transaction_id) return voidYappyLeg(leg);
      if (voucher?.authorizationNumber) return voidCreditDebitLeg(leg);
      return { success: false };
   };

   // Orquesta la devolucion de una orden Mixta: si es parcial, mantiene el comportamiento actual
   // (efectivo, sin intentar reversar nada por gateway). Si es completa, reversa cada pierna por su
   // propio datafono y arma una sola nota de credito con el desglose (piernas reversadas conservan
   // su integracion; piernas que fallaron o no tenian evidencia quedan como efectivo).
   const voidMixedOrder = async (code, approvedBy) => {
      if (!isFullOriginalReturnSelected()) {
         registerOrderTempReturn(code, 3, "Devolucion aplicada con exito.", "Operacion exitosa", "success", { EMVStreamResponse: "0" }, approvedBy);
         return;
      }

      setStateRequest(true);

      const legs = order.paymethods || [];
      const legOutcomes = [];
      for (let i = 0; i < legs.length; i++) {
         const leg = legs[i];
         LoadingAlert("Devolucion mixta en proceso", `Reversando pago ${i + 1} de ${legs.length}...`);
         const legResult = await voidMixedLeg(leg);
         legOutcomes.push({ leg, legResult });
      }

      const paymethodsBreakdown = legOutcomes.map(({ leg, legResult }) => (
         legResult.success
            ? {
               name: leg.name,
               paymethod_id: leg.paymethod_id,
               total: leg.total,
               paymenthod_integration_id: leg.paymenthod_integration_id,
               voucher_response: legResult.voucher_response,
            }
            : {
               // The name must match the paymethod_id (the original method); only the integration changes to cash
               name: leg.name,
               paymethod_id: leg.paymethod_id,
               total: leg.total,
               paymenthod_integration_id: 1,
               voucher_response: 0,
            }
      ));

      await registerOrderTempReturn(
         code,
         3,
         "Devolucion aplicada con exito.",
         "Operacion exitosa",
         "success",
         { EMVStreamResponse: "0" },
         approvedBy,
         undefined,
         { paymethodsBreakdown, keepTemporalOnFailure: true }
      );
   };

   //Function to build the payload for the return order, if the return type is partial we send the selected products, if not we send all the products with a flag to indicate that is a full return
   const getPartialReturnPayload = () => {
      const isPartialDevolution = !isFullOriginalReturnSelected();

      return {
         is_partial_devolution: isPartialDevolution,
         groups: getSelectedReturnProducts("group"),
         combos: getSelectedReturnProducts("combo")
      };
   };
   //register order temporal thwn is aprobed
   const registerOrderTempReturn = async (
      code,
      status,
      message,
      title,
      icon,
      data_bank_voucher_response,
      approved_by,
      reversal_status,
      options = {}
   ) => {
      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'));

      let business_code = options.businessCode || business.code
      let branch_code = options.branchCode || branchoffice.code

      if (!options.businessCode && !options.branchCode && codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      const partialReturnPayload = options.partialReturnPayload || getPartialReturnPayload();
      const orderReference = options.orderReference || transaction_code;


      try {
         const response = await OrderReturnFetchAPI.registerOrderReturn(orderReference, business_code, branch_code, token, data_bank_voucher_response.EMVStreamResponse, approved_by, reversal_status, partialReturnPayload, options.paymethodsBreakdown);
         if (!response?.data?.data?.order_id || !response?.data?.data?.transaction_code) {
            throw new Error("SmartPay no confirmo el registro de la nota de credito.");
         }
         if (typeof options.onBackendRegistered === "function") {
            options.onBackendRegistered(response);
         }
         setStateRequest(false)
         const temporalWasUpdated = await updateTemReturn(code, status, message, title, icon);
         if (!temporalWasUpdated) {
            return { success: true, response, temporalWasUpdated: false };
         }
         printOrder(response.data.data.order_id, response.data.data.transaction_code);

         setDataTransaction_code(response.data.data.transaction_code);
         setOrder_id(response.data.data.order_id);
         setModalConfirmation(true)
         return { success: true, response, temporalWasUpdated: true };
      } catch (err) {
         setStateRequest(false)
         console.log(err);
         if (options.keepTemporalOnFailure === true) {
            ErrorAlert(
               "KinPOS anulo la venta, pero SmartPay no pudo registrar la nota de credito. No repitas la anulacion; el resultado queda pendiente para recuperacion.",
               "Anulacion pendiente de registro",
               "warning",
               12000
            )
         } else {
            await updateTemReturn(code, 5, "No se pudo registrar la nota de credito. Se libero la temporal.", "Error en la devolucion", "error")
         }
         return { success: false, error: err };
      }
   }

   // update order temporal return to delete
   const updateTemReturn = async (code, status, message, title, icon, isTruncate) => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))

      let business_code = business.code
      let branch_code = branchoffice.code

      if (codeParthner != 0) {
         business_code = codeParthner.business_code
         branch_code = codeParthner.branchoffice_code
      }

      let jsonUpdate = {
         "order_code": code,
         "business_code": business_code,
         "branchoffice_code": branch_code,
         "status": status
      }
      try {
         await OrderReturnFetchAPI.updateOrderTempReturn(jsonUpdate, token)
         if (isTruncate == true) {
            createOrderTempReturn()
         } else {
            setOrder({ order: "" })
            ErrorAlert(message, title, icon)
         }
         return true;
      } catch (err) {
         console.log(err);
         setStateRequest(false)
         if (isTruncate == true) {
            ErrorAlert("No se pudo eliminar la temporal anterior.", "Error de temporal", "error")
         } else {
            console.log("[ModalReturn] Error liberando temporal de devolucion procesada", err);
            ErrorAlert(
               "La devolucion fue procesada, pero no se pudo liberar la temporal.",
               "Error eliminando temporal",
               "error",
               10000,
               {
                  detail: [
                     err?.response?.status ? `Status: ${err.response.status}` : "",
                     err?.config?.method || err?.config?.url ? `Endpoint: ${(err?.config?.method || "").toUpperCase()} ${err?.config?.url || ""}`.trim() : "",
                     err?.response?.data?.code ? `Codigo: ${err.response.data.code}` : "",
                     `Contexto: order_code=${code}`,
                  ].filter(Boolean).join(" | "),
               }
            )
         }
         return false;
      }
   }

   const parseVoucherValue = (value) => {
      if (typeof value !== "string") return value;
      try {
         return JSON.parse(value);
      } catch (error) {
         return null;
      }
   };

   const getOriginalKinposReceipt = () => {
      const voucher = parseVoucherValue(bank_voucher_response);
      const nestedVoucher = parseVoucherValue(voucher?.EMVStreamResponse);
      return voucher?.transaction?.receipt || nestedVoucher?.transaction?.receipt || null;
   };

   const voidKinpos = async (code, approvedBy) => {
      const receiptNumber = getOriginalKinposReceipt();
      if (!receiptNumber) {
         await updateTemReturn(
            code,
            5,
            "La venta original no contiene transaction.receipt de KinPOS. No se inicio la anulacion.",
            "Recibo KinPOS no disponible",
            "warning"
         );
         return;
      }

      const branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
      const business = JSON.parse(localStorage.getItem('business'));
      const businessCode = codeParthner != 0 ? codeParthner.business_code : business.code;
      const branchCode = codeParthner != 0 ? codeParthner.branchoffice_code : branchoffice.code;
      const context = {
         temp_order_code: code,
         order_reference: transaction_code,
         business_code: businessCode,
         branchoffice_code: branchCode,
         approved_by: approvedBy,
         partial_return_payload: getPartialReturnPayload(),
      };

      // KinPOS/PAX solo puede anular desde el mismo dispositivo Android que cobro la venta. Si este
      // punto no es el que cobro, enrutamos la anulacion por WebSocket al punto original en vez de
      // bloquear la devolucion.
      const isDifferentOriginPoint = order.origin_machine_code && order.origin_machine_code !== machine.code;
      if (isDifferentOriginPoint) {
         await voidKinposRemote(code, receiptNumber, context, order.origin_machine_code, businessCode, branchCode);
         return;
      }

      if (!kinposPaymentBridge.isAvailable()) {
         await updateTemReturn(
            code,
            5,
            "La integracion KinPOS/PAX no esta disponible en este dispositivo. No se inicio la anulacion.",
            "Bridge KinPOS no disponible",
            "warning"
         );
         return;
      }

      try {
         setStateRequest(true);
         LoadingAlert("Anulacion KinPOS en proceso", "Espere la respuesta del terminal PAX...");
         await kinposPaymentBridge.voidTransaction({
            payment: order,
            orderReference: transaction_code,
            receiptNumber,
            context,
         });
         setStateRequest(false);
         setShow(false);
      } catch (error) {
         await updateTemReturn(
            code,
            5,
            error?.message || "No se pudo solicitar la anulacion al terminal KinPOS/PAX.",
            "Error iniciando anulacion KinPOS",
            "error"
         );
      }
   };

   // Pide al punto original (que hizo el cobro KinPOS) que ejecute el void en su propio
   // AndroidBridge, espera el resultado por WebSocket, y termina el flujo reutilizando
   // handleKinposVoidResult tal cual funciona para un void local.
   const voidKinposRemote = async (code, receiptNumber, context, targetMachineCode, businessCode, branchCode) => {
      let socket;
      try {
         setStateRequest(true);
         LoadingAlert(
            "Anulacion KinPOS en proceso",
            `Solicitando la anulacion al punto original (${order.origin_machine_name || targetMachineCode})...`
         );
         socket = Socket({ machine_code: machine.code, branchoffice_code: branchCode, business_code: businessCode });

         const { remote_request_id, kinpos_request_id, result } = await requestRemoteKinposVoid(socket, {
            targetMachineCode,
            businessCode,
            branchofficeCode: branchCode,
            requestingMachineCode: machine.code,
            orderReference: transaction_code,
            receiptNumber,
            payment: { paymenthod_id: order.paymenthod_id, paymenthod_integration_id: order.paymenthod_integration_id },
            context,
         });

         const success = await handleKinposVoidResult(result);

         confirmRemoteKinposVoid(socket, {
            remoteRequestId: remote_request_id,
            kinposRequestId: kinpos_request_id,
            targetMachineCode,
            businessCode,
            branchofficeCode: branchCode,
            success: success === true,
         });
      } catch (error) {
         await updateTemReturn(
            code,
            5,
            error?.message || "No se pudo contactar el punto original para anular con KinPOS/PAX.",
            "Error en anulacion remota KinPOS",
            "error"
         );
      } finally {
         socket?.disconnect();
      }
   };

   const handleKinposVoidResult = async (result) => {
      if (result.request?.context?.mixed_leg === true) {
         // Pierna de una devolucion mixta (voidKinposLeg): esperar a un estado terminal y resolver
         // la promesa que orquesta voidMixedOrder. No se registra nada aqui ni se hace ACK - eso lo
         // decide el orquestador una vez conocido el resultado combinado de TODAS las piernas.
         if (result.status === "pending" || result.status === "uncertain") return;
         const resolveLeg = kinposLegResolversRef.current.get(result.request_id);
         if (resolveLeg) {
            kinposLegResolversRef.current.delete(result.request_id);
            resolveLeg(result);
         }
         return;
      }

      if (result.status === "pending") {
         setStateRequest(true);
         return;
      }

      if (result.status === "uncertain") {
         setStateRequest(true);
         ErrorAlert(
            result.message || "El resultado de la anulacion aun no ha sido confirmado. No la repitas.",
            "Anulacion KinPOS pendiente",
            "warning",
            12000
         );
         return;
      }

      const context = result.request?.context;
      if (result.status !== "approved") {
         if (context?.temp_order_code) {
            await updateTemReturn(
               context.temp_order_code,
               5,
               result.message || "KinPOS no aprobo la anulacion.",
               "Anulacion KinPOS no aprobada",
               result.status === "cancelled" ? "warning" : "error"
            );
         } else {
            ErrorAlert(
               result.message || "KinPOS no aprobo la anulacion.",
               "Anulacion KinPOS no aprobada",
               "error"
            );
         }
         kinposPaymentBridge.complete(result.request_id);
         setStateRequest(false);
         // No aprobada: no hay nota de credito que registrar, asi que el void queda cerrado
         // (equivalente a "success" desde la perspectiva de si el punto original puede hacer ACK).
         return true;
      }

      const voidRecord = toKinposVoidRecord(result);
      if (
         !voidRecord
         || !context?.temp_order_code
         || !context?.order_reference
         || !context?.business_code
         || !context?.branchoffice_code
         || !context?.partial_return_payload
      ) {
         kinposPaymentBridge.markProcessingFailed(result.request_id);
         setStateRequest(true);
         ErrorAlert(
            "KinPOS anulo la venta, pero falta el contexto necesario para registrar la nota de credito. No repitas la anulacion.",
            "Anulacion pendiente de registro",
            "warning",
            12000
         );
         return false;
      }

      const registration = await registerOrderTempReturn(
         context.temp_order_code,
         3,
         "Devolucion aplicada con exito.",
         "Operacion exitosa",
         "success",
         { EMVStreamResponse: voidRecord },
         context.approved_by,
         undefined,
         {
            businessCode: context.business_code,
            branchCode: context.branchoffice_code,
            orderReference: context.order_reference,
            partialReturnPayload: context.partial_return_payload,
            keepTemporalOnFailure: true,
            onBackendRegistered: () => kinposPaymentBridge.complete(result.request_id),
         }
      );

      if (registration?.success === true) {
         kinposPaymentBridge.complete(result.request_id);
         setStateRequest(false);
         setShow(false);
         return true;
      }

      kinposPaymentBridge.markProcessingFailed(result.request_id);
      setStateRequest(true);
      return false;
   };

   kinposVoidResultHandlerRef.current = handleKinposVoidResult;

   // KinposVoidResultRouter (no kinposPaymentBridge.subscribe directamente): este mismo dispositivo
   // tambien puede ejecutar anulaciones KinPOS por encargo de otro punto (ver
   // KinposRemoteVoidExecutor), asi que el router decide si un resultado "void" es de esta
   // devolucion local o de una devolucion remota ajena.
   useEffect(() => registerLocalKinposVoidHandler(
      (result) => kinposVoidResultHandlerRef.current?.(result)
   ), []);

   useEffect(() => {
      const pendingVoid = kinposPaymentBridge.getPendingPayment();
      if (pendingVoid?.mode !== "void") return;
      kinposPaymentBridge.recover();
   }, []);


   //print order
   const printOrder = async (id_Orden_Imprimir, transaction_code, micros) => {
      let type_ticket = ""
      let imprimir_comanda = ""
      let ip_print = "localhost"

      if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
         ip_print = localStorage.getItem("ip_printer")
      }
      let JsonImprimir = [{
         "type_ticket": "Nota a credito",
         "Printers": printers,
         "Nombre_maquina_impresora": infoPrinter.printer_ticket,
         "Nombre_cocina_impresora": infoPrinter.printer_comanda,
         "Nombre_zebra_impresora": infoPrinter.printer_zebra,
         "PRINTER_IP": infoPrinter.printer_ip,
         "Id_Orden_Imprimir": id_Orden_Imprimir,
         "token": localStorage.getItem('x-access-machine-token'),
         "transaction_code": transaction_code,
         "amount_item": orderSize,
         "imprimir_comanda": "no",
      }]


      printOrderData(JsonImprimir)

      try {
         const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

         if (micros == true) {
            let dataRequestMicros = {
               "body": JsonImprimir, "method": "POST", "url": "http://localhost:9090/impresion"
            }
            const response = await RequestAlohaFetchAPI.requestLocalIp(dataRequestMicros, response_machine.data.data.windows_ip)
         } else {
            if (ip_print == "localhost") {
               const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
            } else {
               const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
            }
         }


      } catch (err) {
         console.log(err);
      }
   }

   //Void credit and debit card
   const voidCreditDebit = async (code, message, title, icon) => {
      console.log(bank_voucher_response);

      let authorizationNumber = bank_voucher_response.authorizationNumber;
      let referenceNumber = bank_voucher_response.referenceNumber;
      let systemTraceNumber = bank_voucher_response.systemTraceNumber;



      try {
         //request get ip windows
         const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
         //request the requesting machine's own payment method config (integration + params of its datáfono), not the order's stored data
         const response_paymentmethod = await PaymentMethodFetchAPI.getPaymentMethod(machine.id, localStorage.getItem('x-access-machine-token'));
         const machinePaymentMethods = Array.isArray(response_paymentmethod.data.data) ? response_paymentmethod.data.data : [];
         const machinePaymentMethod = machinePaymentMethods.find((method) => method.id === order.paymenthod_id) || {};
         //request return total of the transaction
         const json = [{
            Tipo: 'VOID',
            TipoVenta: "VOID",
            authorizationNumber: authorizationNumber,
            referenceNumber: referenceNumber,
            systemTraceNumber: systemTraceNumber,
            paymentMethod: {
               id: order.paymenthod_id,
               payment: order.paymenthod,
               payment_id: order.paymenthod_id,
               machine_id: machine.id,
               params: machinePaymentMethod.params || detailPayment
            }
         }];
         const response = await RequestLocalFetchAPI.postPaymentMethod(json, response_machine.data.data.windows_ip);
         console.log(response.data.data);
         let newVoucher = { EMVStreamResponse: response.data.data.EMVStreamResponse }
         console.log("hola");

         if (response.data.data.EMVStreamResponse.responseCodeDescription) {
            if (response.data.data.EMVStreamResponse.responseCodeDescription == "APROBADA") {
               registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
            } else {
               //ErrorAlert("No se aplico la devlucion.", "Error en la devolucion", "error")
               updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
            }
         } else {
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
            //ErrorAlert("No se aplico la devlucion.", "Error en la devolucion", "error")
         }

      } catch (err) {

         updateTemReturn(code, 5, "Error de conexion con el datáfono.", "Advertencia", "error")
         console.log(err);
      }
   }

   //void evertech
   const voidEvertech = async (code, message, title, icon) => {
      try {

         //request get machine info of the order 
         const response_machine = await MachinesFetchAPI.getmachineByid(order.machine_id, localStorage.getItem('x-access-machine-token'));

         //We make the refund request
         const response = await PaymentOperations({
            operationType: "void",
            integrationType: 'Evertech',
            params: order.paymentmethod_params,
            referenceVoid: order.transaction_code,
            sECRStationID: response_machine.data.data.code,
            sCashierID: order.user.id,
            tips: 0,
            token: token
         });
         //We check if the response is success
         if (response && response.data && response.data.approval_code === "00") {
            console.log("void de evertech", response);
            let newVoucher = {
               EMVStreamResponse: response.data
            };
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            console.log("Error en el void de evertech", response);
            //We show an error alert
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
         }

      } catch (err) {
         console.log(err);
         updateTemReturn(code, 5, 'Error en el void de evertech', "Error en la devolucion", "error")
      }
   }

   //Void banesco 
   const voidBanesco = async (code, message, title, icon) => {
      try {

         //We make the refund request
         const response = await PaymentOperations({
            operationType: "void",
            integrationType: 'Banesco',
            params: order.paymentmethod_params,
            invoice: order.bank_voucher_response.TxnInvoice,
            token: token
         });
         //We check if the response is success
         if (response && response.data && response.data.TxnRspCode === "00") {
            console.log("void de banesco", response);
            let newVoucher = {
               EMVStreamResponse: response.data
            };
            //We register the order return
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            console.log("Error en el void de banesco", response);
            //We show an error alert
            updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
         }

      } catch (err) {
         console.log(err);
         updateTemReturn(code, 5, 'Error en el void de banesco', "Error en la devolucion", "error")
         //ErrorAlert('', 'Error en el void de banesco', 'error')
      }
   }

   //Reversal pluxee qr
   const reversalPluxee = async (code, message, title, icon, machine_id) => {
      try {
         let pluxee_transaction_id = order.pluxee.pluxee_transaction_id;
         let pluxee_instance_id = order.pluxee.pluxee_instance_id;
         console.log(pluxee_transaction_id, pluxee_instance_id, machine_id, token);
         //We get the pluxee transaction
         const response = await PluxeeFetchAPI.getPluxeeTransaction(pluxee_transaction_id, pluxee_instance_id, machine_id, token);
         //We check if the response is success
         if (response && response.data && response.data.data && response.data.data.responseData) {
            //We get the auth code
            let authId = response.data.data.responseData.authId;
            let siteId = response.data.data.responseData.merchant.siteId;
            //We make the reverse on pluxee 
            let reversal = await PluxeeFetchAPI.reversePluxeeTransaction(siteId, authId, machine_id, token);
            console.log(reversal);
            //We check if the response is success
            if (reversal && reversal.data) {
               let newVoucher = {
                  EMVStreamResponse: JSON.stringify({ authID_c: response.data.data.authID_c, source: response.data.data.source })
               };
               registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
            } else {
               console.log("Error en el reverse de pluxee", response);
               //We show an error alert
               updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
            }
         }
      } catch (err) {
         console.log("En el catch Error en el reverse de pluxee", err);
         //We show an error alert
         updateTemReturn(code, 5, "No se aplico la devlucion.", "Error en la devolucion", "error")
      }
   }

   //Reversal pluxee voucher 
   const reversalPluxeeVoucher = async (code, message, title, icon, machine_id) => {
      try {
         let pluxee_authID = order.pluxee_voucher.pluxee_authID;
         //We make the reverse on pluxee 
         let reversal = await PluxeeFetchAPI.reversePluxeeVoucherTransaction(pluxee_authID, machine_id, token);
         //We check if the response is success
         if (reversal && reversal.data) {
            let newVoucher = {
               EMVStreamResponse: JSON.stringify({ responseData: reversal.data.data.responseData })
            };
            registerOrderTempReturn(code, 3, message, title, icon, newVoucher);
         } else {
            console.log("Error en el reverse voucer de pluxee", reversal);
            //We show an error alert
            updateTemReturn(code, 5, "No se aplico la devolucion.", "Error en la devolucion", "error")
         }
      } catch (err) {
         console.log("En el catch Error en el reverse voucher de pluxee", err);
         //We show an error alert
         updateTemReturn(code, 5, "No se aplico la devolucion.", "Error en la devolucion", "error")
      }
   }
   // Disponible / Devuelto text of a line: units, or money once the line is refunded by amount
   const returnAvailabilityText = (product) => (
      isAmountOnlyLine(product)
         ? `Disponible: $ ${roundCurrency(getReturnableValue(product)).toFixed(2)} / Devuelto: $ ${toNumber(product.returned_value).toFixed(2)}`
         : `Disponible: ${getReturnableAmount(product)} / Devuelto: ${toNumber(product.returned_amount)}`
   );

   // Units / amount switch and the amount field of a selected line
   const returnModeControls = (product, type, selectedItem) => {
      if (!selectedItem || getReturnableAmount(product) <= 0) return null;

      const amountOnly = isAmountOnlyLine(product);
      const isAmountMode = selectedItem.mode === "amount";
      const maxValue = roundCurrency(getReturnableValue(product));
      const issue = isAmountMode ? getAmountSelectionIssue(selectedItem) : "";
      const typedValue = parseReturnValue(selectedItem.value);
      const split = isAmountMode && !issue ? splitGrossRefundValue(typedValue, product.taxes) : null;
      const hasRoundingAdjustment = split && Math.abs(split.gross - typedValue) >= 0.005;

      return (
         <div className="mb-2" onClick={(event) => event.preventDefault()}>
            <div className="btn-group btn-group-sm" role="group" aria-label={`Tipo de devolucion de ${product.name}`}>
               <button
                  type="button"
                  className={`btn ${!isAmountMode ? "btn-primary" : "btn-outline-primary"}`}
                  disabled={amountOnly}
                  onClick={() => handleReturnModeChange(product, type, "units")}
               >
                  Unidades
               </button>
               <button
                  type="button"
                  className={`btn ${isAmountMode ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => handleReturnModeChange(product, type, "amount")}
               >
                  Monto
               </button>
            </div>

            {isAmountMode && (
               <>
                  <div className="input-group input-group-sm mt-2" style={{ maxWidth: "190px" }}>
                     <span className="input-group-text">$</span>
                     <input
                        className="form-control"
                        type="number"
                        inputMode="decimal"
                        min="0.01"
                        max={maxValue}
                        step="0.01"
                        value={selectedItem.value}
                        onChange={(event) => handleReturnValueChange(product, type, event.target.value)}
                        aria-label={`Monto a devolver de ${product.name}`}
                     />
                     <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => handleReturnValueChange(product, type, maxValue.toFixed(2))}
                     >
                        Máx
                     </button>
                  </div>
                  <small className={issue ? "text-danger fw-bold d-block mt-1" : "text-muted d-block mt-1"}>
                     {issue || (hasRoundingAdjustment
                        ? `Se devolverá $ ${split.gross.toFixed(2)} (ajuste por redondeo del ITBMS).`
                        : `Máx. $ ${maxValue.toFixed(2)} con ITBMS incluido.`)}
                  </small>
               </>
            )}
         </div>
      );
   };

   // view get order to return
   const cardGetOrder = () => {
      const cardOrder = order.groups.map((product) => {
         const key = getReturnItemKey(product, "group");
         const selectedItem = findSelectedReturnItem(product, "group");
         const checked = Boolean(selectedItem);
         const remainingAmount = getReturnableAmount(product);
         const selectedAmount = selectedItem?.amount || "";
         const isFullyReturned = remainingAmount <= 0;

         return (
            <div className="d-flex text-muted pt-3 px-xs-2 border-bottom" key={key}>
               <div className="form-check d-flex align-items-start me-2 pt-2">
                  <input
                     className="form-check-input"
                     type="checkbox"
                     checked={checked}
                     disabled={isFullyReturned}
                     onChange={() => toggleProductToReturn(product, "group")}
                     id={key}
                  />
               </div>

               <img
                  className="bd-placeholder-img flex-shrink-0 me-2 rounded bg-secondary"
                  loading='lazy'
                  src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage}
                  width="42"
                  height="42"
               />

               <label className="pb-3 mb-0 lh-sm w-100" htmlFor={key}>
                  <div className="d-flex justify-content-between">
                     <span className="text-dark fw-bold title-product">{product.name}</span>

                     <span className='px-1 number-counter'>
                        <p>{product.amount}</p>
                     </span>

                     <span className="fw-bold">$ {toNumber(product.price).toFixed(2)}</span>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 my-2">
                     <small className={isFullyReturned ? "text-danger fw-bold" : "text-primary fw-bold"}>
                        {returnAvailabilityText(product)}
                     </small>
                     {!isAmountOnlyLine(product) && selectedItem?.mode !== "amount" && (
                        <select
                           className="form-select form-select-sm"
                           style={{ maxWidth: "90px" }}
                           value={selectedAmount}
                           disabled={!checked || isFullyReturned}
                           onChange={(event) => handleReturnQuantityChange(product, "group", event.target.value)}
                           aria-label={`Cantidad a devolver de ${product.name}`}
                        >
                           <option value=""></option>
                           {getReturnQuantityOptions(remainingAmount).map(amount => (
                              <option value={amount} key={`${key}-quantity-${amount}`}>{amount || "0"}</option>
                           ))}
                        </select>
                     )}
                  </div>

                  {returnModeControls(product, "group", selectedItem)}

                  <details open>
                     <summary><small>Detalles</small></summary>
                     {product.segments.map(item => (
                        <div key={`${key}-${item.segment_name}-${item.name}`}>
                           <small>{item.segment_name}: {item.name} - ${item.price}</small>
                        </div>
                     ))}
                  </details>
               </label>
            </div>
         );
      });

      return cardOrder;
   };

   //Template card Group of setGroup
   const cardGroup = (product) => {
      return (
         <div className="card-group">
            <div className="card">
               <div className='d-flex justify-constent- between'>
                  <img loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} className='m-2' alt="..." width="50" height="50" />
                  <div className="card-body">
                     <h5 className="card-title">{product.name}</h5>
                     <details close >
                        <summary className=''>
                           <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                              <i className="uil uil-info-circle  px-1 "></i>  Detalles
                           </span>
                        </summary>
                        {product.segments.map(item => (
                           <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                              {/* <span className='kiosk-subtitle-s' >   </span> */}
                              <span className='text-muted m-0 p-0'>{item.name}:</span>
                              <br />
                              <strong>
                                 <span className='me-2'>{item.item.name} </span>
                                 {parseFloat(item.item.price).toFixed(2)}
                              </strong>
                           </span>
                        ))}
                     </details>
                  </div>
               </div>
            </div>
         </div>
      )
   }

   const orderCombos = () => {
      let items = order.combos.map((product) => {
         const key = getReturnItemKey(product, "combo");
         const selectedItem = findSelectedReturnItem(product, "combo");
         const checked = Boolean(selectedItem);
         const remainingAmount = getReturnableAmount(product);
         const selectedAmount = selectedItem?.amount || "";
         const isFullyReturned = remainingAmount <= 0;

         return (
            <div className="d-flex text-muted pt-3 px-xs-2 border-bottom" key={key}>
               <div className="form-check d-flex align-items-start me-2 pt-2">
                  <input
                     className="form-check-input"
                     type="checkbox"
                     checked={checked}
                     disabled={isFullyReturned}
                     onChange={() => toggleProductToReturn(product, "combo")}
                     id={key}
                  />
               </div>

               <img
                  className="bd-placeholder-img flex-shrink-0 me-2 rounded"
                  loading='lazy'
                  src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage}
                  width="42"
                  height="42"
               />

               <label className="pb-3 mb-0 lh-sm w-100" htmlFor={key}>
                  <div className="d-flex justify-content-between">
                     <span className="text-dark fw-bold">{product.name}</span>

                     <div>
                        <span className='px-3'>x {product.amount}</span>
                        <span className="fw-bold" translate='no'>$ {toNumber(product.price).toFixed(2)}</span>
                     </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 my-2">
                     <small className={isFullyReturned ? "text-danger fw-bold" : "text-primary fw-bold"}>
                        {returnAvailabilityText(product)}
                     </small>
                     {!isAmountOnlyLine(product) && selectedItem?.mode !== "amount" && (
                        <select
                           className="form-select form-select-sm"
                           style={{ maxWidth: "90px" }}
                           value={selectedAmount}
                           disabled={!checked || isFullyReturned}
                           onChange={(event) => handleReturnQuantityChange(product, "combo", event.target.value)}
                           aria-label={`Cantidad a devolver de ${product.name}`}
                        >
                           <option value=""></option>
                           {getReturnQuantityOptions(remainingAmount).map(amount => (
                              <option value={amount} key={`${key}-quantity-${amount}`}>{amount}</option>
                           ))}
                        </select>
                     )}
                  </div>

                  {returnModeControls(product, "combo", selectedItem)}

                  {product.setGroups.map((setGroup) => (
                     <div className="d-flex justify-content-between" key={setGroup.set_id}>
                        <details close="">
                           <summary>
                              <span className='badge bg-light text-dark summary-text-pos fw-bold border rounded-4 text-wrap m-1'>
                                 <i className="uil uil-info-circle px-1"> {setGroup.name}</i>
                              </span>
                           </summary>

                           {setGroup.groups.map((group) => (
                              <React.Fragment key={group.group_id}>
                                 {cardGroup(group)}
                              </React.Fragment>
                           ))}
                        </details>
                     </div>
                  ))}

                  <div>
                     <small className='text-primary p-1'>
                        Entrega: {product.delivery_type}
                     </small>
                  </div>

                  <RenderIf isTrue={product.note != ""}>
                     <small className='text-danger p-1'>
                        Nota: {product.note}
                     </small>
                  </RenderIf>
               </label>
            </div>
         );
      });

      return <>{items}</>;
   };

   const selectedReturnTotals = getSelectedReturnTotals();
   const returnableProductsCount = getAllProductsToReturn(order).length;
   const allReturnProducts = getAllProductsToReturn(order, true);
   const summaryOriginalItems = toNumber(devolutionSummary?.total_original_items)
      || allReturnProducts.reduce((total, item) => total + toNumber(item.product.return_original_amount ?? item.product.amount), 0);
   const summaryReturnedItems = toNumber(devolutionSummary?.total_returned_items)
      || allReturnProducts.reduce((total, item) => total + toNumber(item.product.returned_amount), 0);
   const summaryRemainingItems = toNumber(devolutionSummary?.total_remaining_items)
      || allReturnProducts.reduce((total, item) => total + getReturnableAmount(item.product), 0);
   const hasReturnedItems = summaryReturnedItems > 0;
   const hasOrderLoaded = Array.isArray(order.groups);
   const kinposVoidPending = kinposPaymentBridge.getPendingPayment()?.mode === "void";

   return (
      <>
         <button className=' p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary'
            onClick={() => (setShow(true), getPrinter())}>
            <i class="uil uil-history-alt icon"></i>
            <small className='fw-bold text '>
               Devolución
            </small>
         </button>

         <Modal
            show={show}
            size="md"
            onHide={() => setShow(false)}
            aria-labelledby="example-custom-modal-styling-title"
            centered
         >
            <div className='mt-2 text-center p-1'>
               <h4 className='fw-bold'><FaHistory /> Devolución </h4>
            </div>

            <Modal.Body>
               <div className='d-lg-flex justify-content-lg-between p-2'>
                  <form class="">
                     <input type="text" class="form-control border w-100" id="floatingInputValue"
                        placeholder="Ingrese número de orden" onChange={(e) => (setTransaction_code(e.target.value))} />
                  </form>
                  <div className='d-flex d-sm-block  justify-content-end mt-sm-0 mt-2 bor'>
                     <button className='btn btn-primary bg-primary-subtle text-primary border-0 fw-bold  ' onClick={async () => (getOrder())}>
                        <i class="uil uil-search-alt pe-1"></i>
                        Buscar orden </button>
                  </div>
               </div>

               <div className='p-2'>
                  {!order.groups ? "" : <>
                     <div className='row'>
                        <div className='col-sm-6'>
                           <a href="#" className="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">
                              <div className="d-flex gap-2 w-100 justify-content-around">
                                 <div>
                                    <h5 className="mb-0">Orden - {order.transaction_code}</h5>
                                    <p className="mb-0 opacity-75">Fecha - {order.createdAt.slice(0, 10)}</p>
                                 </div>
                              </div>
                           </a>
                        </div>
                        <div className='col-sm-6'>
                           <a href="#" className="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">
                              <div className="d-flex gap-2 w-100 justify-content-around">
                                 <div>
                                    <h5 className="mb-0">{order.client_name}</h5>
                                    <p className="mb-0 opacity-75">ruc: {order.client_ruc} dv: {order.client_dv}</p>
                                 </div>
                              </div>
                           </a>
                        </div>
                     </div>
                     <div className={`alert ${returnableProductsCount === 0 ? "alert-danger" : hasReturnedItems ? "alert-warning" : "alert-info"} py-2 my-2`} role="alert">
                        <div className="d-flex justify-content-between flex-wrap gap-2">
                           <span><b>Original:</b> {summaryOriginalItems}</span>
                           <span><b>Ya devuelto:</b> {summaryReturnedItems}</span>
                           <span><b>Disponible:</b> {summaryRemainingItems}</span>
                        </div>
                        {returnableProductsCount === 0 ? (
                           <small>No quedan productos disponibles para nota de credito.</small>
                        ) : hasReturnedItems ? (
                           <small>Solo puedes devolver las cantidades disponibles que no han sido devueltas.</small>
                        ) : (
                           <small>Esta orden aun no tiene productos devueltos.</small>
                        )}
                     </div>
                     <div className=''>
                        <div className="d-flex justify-content-between align-items-center my-2">
                           <small className="text-muted">
                              Seleccionados: {selectedProductsToReturn.length} / {returnableProductsCount}
                           </small>
                           <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={toggleSelectAllProductsToReturn}
                              disabled={returnableProductsCount === 0}
                           >
                              {selectedProductsToReturn.length === returnableProductsCount ? "Quitar todos" : "Seleccionar disponibles"}
                           </button>
                        </div>
                        {cardGetOrder()}
                        {orderCombos()}</div>
                     <div className=''>
                        <div className="order-total mt-2 mx-1">
                           <p className='text-size-order' >Descuento: <span>$ <strong>{order.discount.toFixed(2)}</strong></span> </p>
                           <p className='text-size-order '>Subtotal: <span>$ <strong>{order.subtotal.toFixed(2)}</strong></span></p>
                           {orderTaxes.map((tax) => (
                              <><p className='text-size-order' >Impuestos {tax.tax}: <span>$ <strong>{tax.total.toFixed(3)}</strong></span> </p></>
                           ))}
                           <p className='text-size-order' > <b>Total con impuesto:</b>  <span>$ <strong>{order.total.toFixed(2)}</strong></span></p>
                           <p className='text-size-order text-primary' > <b>Total a devolver:</b>  <span>$ <strong>{selectedReturnTotals.total.toFixed(2)}</strong></span></p>
                        </div>
                     </div>
                  </>}
               </div>

               <div className='d-flex justify-content-between justify-content-lg-end mt-2'>
                  <button
                     className='btn bg-danger-subtle text-danger border-0 fw-bold'
                     onClick={() => {
                        setShow(false);
                        setOrder({ order: "" });
                        setSelectedProductsToReturn([]);
                        setDevolutionSummary({ items: [], total_returned_items: 0 });
                     }}
                  >
                     Cancelar
                  </button>

                  {devolution_validation == 0 ? (
                     <button
                        className='btn bg-success-subtle text-success fw-bold border-0 ms-1'
                        onClick={handleReturnAction}
                        disabled={stateRequest || kinposVoidPending || !hasOrderLoaded || returnableProductsCount === 0}
                     >
                        Generar devolución
                     </button>
                  ) : (
                     <button
                        className='btn bg-success-subtle text-success fw-bold border-0 ms-1'
                        onClick={handleReturnAction}
                        disabled={stateRequest || kinposVoidPending || !hasOrderLoaded || returnableProductsCount === 0}
                     >
                        Aplicar
                     </button>
                  )}
               </div>


            </Modal.Body>
         </Modal>


         <Modal
            show={ModalConfirmation}
            size="md"
            onHide={() => setModalConfirmation(false)}
            backdrop="static"
            centered
         >

            <Modal.Body>
               <div className="bg-light border-sp d-flex align-items-center justify-content-center ">
                  <img className='m-2' src={imgCheck} width="60px"></img>
                  <div>
                     <h1 className='text-center'>Orden: {datatransaction_code}</h1>
                     <div className=" col-md-12 d-flex  p-2 text-center" >
                        <span className="text-muted border border-2 rounded-3 p-1  w-100 bg-light"> Nota acrediro realizada
                        </span>
                     </div>
                  </div>
               </div>

               <div className="m-3 d-flex align-items-center justify-content-center ">
                  <Button className='m-1' variant='success btn-lg' onClick={() => setModalConfirmation(false)}>Continuar</Button>
                  <RenderIf isTrue={pos_integration_name == "Micros"}><Button className='m-1' variant='success btn-lg' onClick={() => printOrder(order_id, datatransaction_code, true)}>Imprimir en quiosco</Button></RenderIf>
               </div>
            </Modal.Body>
         </Modal>


      </>
   )
}

export default ModalReturn
